export default "__VITE_ASSET__C57UMwgG__"